// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__DHqXh","containerItemsCenter":"Skeleton_containerItemsCenter__2MRBB"};